import { createContext } from 'react';

// Lets every prefix/suffix addon within an ObjectTable share the same width as the
// widest one in that table — prefixes and suffixes are tracked separately since they
// aren't visually related. Each field reports its own measured width on mount (and
// whenever its prefix/suffix content changes); the max only ever grows within a
// session — fine since prefix/suffix values don't change once a form has rendered.
export interface ObjectTableAddonWidths {
  reportPrefixWidth: (width: number) => void;
  reportSuffixWidth: (width: number) => void;
  maxPrefixWidth: number | undefined;
  maxSuffixWidth: number | undefined;
}

const ObjectTableContext = createContext<ObjectTableAddonWidths | null>(null);

export default ObjectTableContext;
